import { Component, ElementRef, inject, ViewChild, viewChild} from '@angular/core';
import { loadURLSVGs} from '@dds-uicore/all';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from './data.service';
import { AgileSDKService } from './services/agile-sdk.service';
import { URLParams } from './model/urlparams';
import { environment } from 'src/environments/environment';
import { NgProgressbar } from 'ngx-progressbar';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {


  // startedClass = false;
  // completedClass = false;
  preventAbuse = false;
  @ViewChild("progressBar", { static: false }) progressBar: NgProgressbar;



  // onStarted() {
  //   this.startedClass = true;
  //   setTimeout(() => {
  //     this.startedClass = false;
  //   }, 800);
  // }

  // onCompleted() {
  //   this.completedClass = true;
  //   setTimeout(() => {
  //     this.completedClass = false;
  //   }, 800);
  // }
 title = 'Attachment Utility'
 public viewMode: String = 'LoggingIn';
 userId:string = "User";
 preferredFM:string = "IFS";
//  public viewMode: string = 'Authenticated';
 public decodedToken;
 public ssoEmail : string;
 public ssoBadge : string
 public ssoUsername : string
 posts = []

 isLoading : boolean = true;
 isError:boolean = false;
 errorMessage:string = '';

  constructor(private router: Router, private dataService : DataService, private activatedRoute:ActivatedRoute,private agileService:AgileSDKService) {

  }

  ngOnInit() {
    console.log(localStorage.getItem('acc_enabled'));

    console.log(' current environment ',environment.envName);
    // let accelerationEnabled = localStorage.getItem('acceleration_enabled').valueOf();
    // if(accelerationEnabled == undefined)
    // {
    //   localStorage.setItem('acceleration_enabled',"no");
    //   accelerationEnabled = localStorage.getItem('acceleration_enabled').valueOf();
    // }


    // this.dataService.setIsLoading(false);
    // this.isLoading = false;
    // this.router.navigate(['home'],{skipLocationChange:true})
    // this.isLoading = this.dataService.isLoading
    // this.dataService.getFileTypeCodeRes();
    // for local use, comment here
    //start
    // this.dataService.setIsLoading(true);



    this.dataService.setLoadingMessage("Loading...");
    console.log('Calling the query Map ',this.dataService.getUrlParams())
    this.activatedRoute.queryParamMap.subscribe(

      params => {
        console.log('Params ',params)
        if(params.keys.length > 0){
          console.log('Params ',params);

          this.dataService.setQueryParams(params);

          console.log('Context Name ',params.get('ContextName'))
          if(params.get('ContextName') != undefined){
          this.dataService.setLoadingMessage('Getting session info...')
          this.agileService.getUserSessionInfo(params.get('ContextName'),params.get('agile.userName')).subscribe(
            (response) => {
              this.dataService.setUserSessionInfo(response);

              // console.log('User Session Info Response ',response);
              console.log('User session is open? ',response.sessionOpen)
              if(response.sessionOpen)
              {
                this.userId = response.userInfo.userName;
                // console.log('Here 1 ')
                // this.dataService.setLoadingMessage('Hi '+response.userInfo.userFirstName+", setting things up...")
                // this.userId = response.userInfo.userName;
                // this.preferredFM = response.userInfo.userPreferredFM;
                // get the privilege info
                let urlParams:URLParams = this.dataService.getUrlParams();
                this.agileService.setUrlParms(urlParams);
                this.agileService.getUserPrivilegeInfo(urlParams.partNumber,urlParams.partRevision,urlParams.partClass,urlParams.userName,response.userInfo.userCategory,urlParams.changeNumber).subscribe
                (
                  (privilegeInfo) =>
                  {
                    // console.log('Here 2 ')
                    this.dataService.setUserPrivilegeInfo(privilegeInfo);
                    console.log('Privilege Info ',privilegeInfo)
                    this.dataService.setIsLoading(false);
                    this.isLoading = false;
                    console.log('Navigating to home component ')

                    this.router.navigate(['home'],{skipLocationChange:true})
                  }
                )
              }else
              {
                // unable to validate the session
                // console.log('Here 3 ')
                // this.isLoading = false;
                this.isError = true;
                this.errorMessage = 'Unable to validate Agile session, please try again from Agile..'
                // this.dataService.setLoadingMessage('Unable to validate Agile session, please try again from Agile..')
              }
            }
          )
          }
        }
      }
    )
    //end

    loadURLSVGs([
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__search.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__handle.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__chevron-right.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__chevron-left.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__loading-sqrs.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__chevron-right.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__arrow-tri-solid-right.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__gear.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__doc-check.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__close-cir.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__pause-sqr.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__doc-lines.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__folder.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__arrow-left.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__arrow-tri-solid-stacked.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__cancelled.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__refresh-spin.svg"

    ]);
  }

}
